<template>
  <div class="snkday-reassurance row">
    <div class="snkday-reassurance__item col-xs-12 col-md-4">
      Sans engagement.<br />
      Annulable à tout moment.
    </div>
    <div class="snkday-reassurance__item col-xs-12 col-md-4">
      Votre paire vous sera livré à votre domicile sous 5 à 10 jours
    </div>
    <div class="snkday-reassurance__item col-xs-12 col-md-4">
      Nous vous enverrons un rappel 5 jours avant la fin de votre abonnement.
    </div>
  </div>
</template>

<script>
export default {
  name: "BasketReassurance"
};
</script>

<style lang="scss">
.snkday-reassurance {
  background: #fcfbfb;
  padding: 2rem;
  font-size: 1.4rem;

  @media #{$md-and-down} {
    order: 1;
  }

  &__item {
    display: flex;
    align-items: center;

    @media #{$md-and-down} {
      margin-bottom: 2rem;
    }

    &::before {
      content: "";
      display: block;
      flex: 0 0 auto;
      width: 2rem;
      height: 2rem;
      margin-right: 2rem;
      background: url("~@/assets/images/ic_check.svg") no-repeat;
      background-size: 100%;
    }
  }
}
</style>
